import { $el, $elParent } from 'src/scripts/utils/utils'
import { BaseComponent } from '../base-component'
import { CarouselComponent } from '../carousel/carousel'

const POSTER_SELECTOR = '[id^="Deferred-Poster-"]'
const CAROUSEL_SELECTOR = 'carousel-component'
const SLIDE_ATTRIBUTE = '[data-media-id]'
const AUTOPLAY_ATTRIBUTE = 'data-autoplay'
const CONTROLS_ATTRIBUTE = 'data-enable-controls'

export class DeferredMedia extends BaseComponent {
  carousel: CarouselComponent
  video: HTMLVideoElement
  isTouched: boolean

  mountComponent(): void {
    this.carousel = $elParent(CAROUSEL_SELECTOR, this)
    this.carousel?.embla.on('settle', this.handleCarouselSettle)

    if (this.hasAttribute(AUTOPLAY_ATTRIBUTE)) {
      this.loadContent()
    } else {
      this.addListener(this, 'click', this.handlePosterClick)
    }
  }

  unmountComponent(): void {
    this.carousel?.embla.off('settle', this.handleCarouselSettle)
  }

  handleCarouselSettle = (): void => {
    if (this.video?.tagName === 'VIDEO') {
      const slide = $elParent(SLIDE_ATTRIBUTE, this)
      const isSelected = slide.className.includes('is-selected')

      if (isSelected && this.isTouched) {
        return
      }
      const withAutoplay = this.video.hasAttribute('autoplay')

      if (isSelected && withAutoplay) {
        this.video.play()
      } else if (!isSelected) {
        this.video.pause()
        this.isTouched = false
      }
    }
  }

  handlePosterClick = (event: MouseEvent): void => {
    const poster = $elParent(POSTER_SELECTOR, event.target)

    if (poster) {
      this.loadContent()
    }
  }

  handleUncontrolledVideoClick = (): void => {
    if (this.video.paused) {
      this.video.play()
    } else {
      this.video.pause()
    }

    this.isTouched = true
  }

  loadContent(): void {
    if (!this.getAttribute('loaded')) {
      this.addVideo()
      this.setAttribute('loaded', 'true')
    }
  }

  removeVideo(): void {
    const video = $el('video,  iframe', this)

    if (video) {
      video.remove()
      this.removeAttribute('loaded')
    }
  }

  addVideo(): void {
    const content = document.createElement('div')
    const template: HTMLTemplateElement = $el('template', this)
    const templateContent = template?.content

    if (!templateContent || !templateContent.firstElementChild) {
      return
    }

    const firstChild = templateContent.firstElementChild.cloneNode(true)

    content.appendChild(firstChild)
    const video: HTMLVideoElement = $el('video, model-viewer, iframe', content)

    if (!video) {
      return
    }

    this.appendChild(video)

    this.video = video

    if (video.tagName === 'VIDEO') {
      this.video.play()

      if (!this.hasAttribute(CONTROLS_ATTRIBUTE)) {
        this.addListener(this, 'click', this.handleUncontrolledVideoClick)
      }
    }
  }
}
